module.exports = __webpack_public_path__ + "static/media/side-potrait.2c36d09d.png";